<!--
SDEV-FILE
Copyright (c) 2026 SDEV. All rights reserved.
Workspace: clientside
File: Table.vue
Created: 2026-03-13T17:52:24.541Z
-->

<!--
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
-->
<template>

    <table class="sdev-table">

        <!-- HEADER -->
        <thead>
            <tr>
                <th v-for="col in cols" :key="col.key">
                    {{ col.label }}
                </th>
            </tr>
        </thead>

        <!-- BODY -->
        <tbody>

            <tr v-for="(row, index) in rows" :key="row[rowKey] ?? index" @click="handleRowClick(row)"
                :class="{ 'sdev-table-clickable': clickable }">

                <td v-for="col in cols" :key="col.key">

                    <slot :name="`cell-${col.key}`" :row="row" :value="row[col.key]" :col="col">
                        {{ row[col.key] }}
                    </slot>

                </td>

            </tr>

            <tr v-if="!rows || rows.length === 0">
                <td :colspan="cols.length" class="sdev-table-empty">
                    No data
                </td>
            </tr>

        </tbody>

    </table>

</template>

<script setup>

const props = defineProps({

    cols: { type: Array, required: true },

    rows: { type: Array, default: () => [] },

    rowKey: { type: String, default: "key" },

    clickable: { type: Boolean, default: true }

})

const emit = defineEmits(["select"])

function handleRowClick(row) {

    if (!props.clickable) return

    emit("select", row)

}

</script>